import {
  Box,
  createStandaloneToast,
  UseToastOptions,
  Text,
  CloseButton,
  Flex,
  Icon,
} from "@chakra-ui/react";
import { MdCheckCircle, MdError, MdWarning, MdInfo, MdHourglassEmpty } from "react-icons/md";

const { toast } = createStandaloneToast();

const STATUS_CONFIG = {
  success: { bg: "green.50", border: "green.500", text: "green.700", icon: MdCheckCircle },
  error: { bg: "red.50", border: "red.500", text: "red.700", icon: MdError },
  warning: { bg: "yellow.50", border: "yellow.500", text: "yellow.700", icon: MdWarning },
  info: { bg: "blue.50", border: "blue.500", text: "blue.700", icon: MdInfo },
  loading: { bg: "gray.50", border: "gray.500", text: "gray.700", icon: MdHourglassEmpty },
};

const showToast = (
  title: string,
  description: string,
  status: UseToastOptions["status"]
) => {
  const { bg, border, text, icon } = STATUS_CONFIG[status || "info"];

  toast({
    position: "bottom-right",
    duration: 7000,
    isClosable: true,
    render: ({ onClose }) => (
      <Box
        p={3}
        bg={bg}
        border="1px solid"
        borderColor={border}
        borderRadius="md"
        boxShadow="sm"
        width="400px"
      >
        <Flex justifyContent="space-between" alignItems="center">
          <Flex align="center" gap={2} flex={1} mr={2}>
            <Icon as={icon} boxSize={6} flexShrink={0} color={text} />
            <Box>
              <Text fontWeight="700" mb={0} fontSize="sm" color={text}>
                {title}
              </Text>
              {description && <Text fontSize="xs" mb={0} color={text}>{description}</Text>}
            </Box>
          </Flex>
          <CloseButton size="xs" onClick={onClose} color={text} flexShrink={0} />
        </Flex>
      </Box>
    ),
  });
};

export default showToast;
